import script from "./TextDiff.vue?vue&type=script&setup=true&lang=js"
export * from "./TextDiff.vue?vue&type=script&setup=true&lang=js"

import "./TextDiff.vue?vue&type=style&index=0&id=dfd2c414&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfd2c414"]])

export default __exports__